<template>
  <FormSelect
    :value="value"
    @input="updateRate"
    :optionsPromise="salesRateOptionsPromise"
    :placeholder="placeholder"
    :field="field"
    :note="note"
  />
</template>

<script>
import _ from 'lodash'
export default {
  name: 'SalesRateSelect',
  props: {
    value: [String, Number],
    placeholder: String,
    field: String,
    note: String,
    selectDefault: {
      type: Boolean,
      default: true
    },
    showNone: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultSalesRateId: 0,
      salesRateOptionsPromise: this.getSalesRateOptionsPromise()
    }
  },
  methods: {
    getSalesRateOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.pricingService.getSalesRateList()
        .then(response => {

          this.defaultSalesRateId = 0
          response.data.forEach(salesRate => {
            if(salesRate.isActive && salesRate.isDefault)
              this.defaultSalesRateId = salesRate.id
          })

          var salesRateOptions = response.data.map(salesRate => {
            return { value: salesRate.id, name: `${salesRate.code} | ${salesRate.name}` }
          })

          if(this.selectDefault && this.defaultSalesRateId != 0 && this.value == null) {
            this.$nextTick(() => {
              this.$emit('input', this.defaultSalesRateId)
            })
          }

          if(this.$props.showNone)
            return resolve(_.concat({ value: null, name: 'None' }, salesRateOptions))

          return resolve(salesRateOptions)
        })
        .catch(err => { reject(err) })
      })
    },
    updateRate(value) {
      if(value == null)
        this.$emit('input', null)
      else
        this.$emit('input', parseInt(value))
    }
  }
}
</script>